import React, { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { jwtDecode } from "jwt-decode";
import { useSidebar } from "../context/SidebarContext";
import { 
  FaClock, FaChartBar, FaLock, FaCogs, FaQrcode, FaUserCheck, 
  FaFilePdf, FaUsers, FaBell, FaWifi, FaMobileAlt, FaIdBadge,
  FaLightbulb, FaTrophy, FaStar, FaMedal, FaGift
} from "react-icons/fa";
import logo from '../assets/images/application.png';

function About() {
  const { authTokens } = useContext(AuthContext);
  const { sidebarVisible } = useSidebar();

  let role = null;
  let isAuthenticated = false;

  if (authTokens) {
    const decoded = jwtDecode(authTokens.access);
    role = decoded.role;
    isAuthenticated = true;
  }

  const showSidebar = isAuthenticated && sidebarVisible && role !== "EMPLOYE";

  return (
    <div style={{ 
      marginLeft: showSidebar ? "250px" : "0", 
      transition: "margin-left 0.3s ease", 
      fontFamily: "'Inter', sans-serif", 
      color: "#333" 
    }}>
      <main style={{ padding: "50px 20px", maxWidth: "1200px", margin: "auto" }}>

        {/* Hero Section */}
        <section style={{
          textAlign: "center",
          padding: "80px 20px",
          borderRadius: "12px",
          background: "linear-gradient(135deg, #1B019B, #4A47A3)",
          color: "white",
          marginBottom: "60px",
          boxShadow: "0px 6px 15px rgba(0,0,0,0.2)"
        }}>
          <h3 style={{ fontSize: "3rem", fontWeight: 700 }}>🌟 À propos de notre solution RH intelligente</h3>
          <p style={{ fontSize: "1.25rem", marginTop: "20px", maxWidth: "850px", margin: "20px auto 0 auto", lineHeight: "1.7" }}>
            Une plateforme complète pour gérer les présences, retards et absences de vos équipes. 
            Notre application mobile permet de pointer rapidement via QR Code ou badge, et les responsables 
            peuvent superviser et gérer les pointages en temps réel.
          </p>
        </section>

        {/* Site Web */}
        <section style={{ 
          marginBottom: "60px", 
          textAlign: "center",
          padding: "30px",
          background: "linear-gradient(135deg, #f8f9fa, #ffffff)",
          borderRadius: "12px",
          border: "1px solid #e5e7eb"
        }}>
          <h2 style={{ fontWeight: 700, fontSize: "1.8rem", marginBottom: "20px", color: "#1B019B" }}>
            🌐 Découvrez notre écosystème
          </h2>
          <p style={{ fontSize: "1.1rem", marginBottom: "15px" }}>
            Visitez notre site web pour en savoir plus sur nos solutions innovantes
          </p>
          <a 
            href="https://enumera.africa" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: "inline-block",
              backgroundColor: "#1B019B",
              color: "white",
              padding: "12px 30px",
              borderRadius: "30px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "1.1rem",
              transition: "transform 0.3s, box-shadow 0.3s",
              boxShadow: "0 4px 15px rgba(27, 1, 155, 0.3)"
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(27, 1, 155, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(27, 1, 155, 0.3)";
            }}
          >
            enumera.africa
          </a>
        </section>

        {/* Pourquoi nous choisir */}
        <section style={{ marginBottom: "60px" }}>
          <h2 style={{ fontWeight: 700, fontSize: "2rem", textAlign: "center", marginBottom: "50px" }}>🌟 Pourquoi choisir notre solution ?</h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "30px"
          }}>
            {[
              { icon: FaClock, title: "Gain de temps", desc: "Automatisation du suivi et des rapports pour une productivité optimale." },
              { icon: FaChartBar, title: "Analyses instantanées", desc: "Statistiques et rapports fiables pour une meilleure prise de décision." },
              { icon: FaLock, title: "Sécurité & Confiance", desc: "Authentification sécurisée, photos prise lors des pointages et protection totale des données." },
              { icon: FaCogs, title: "Flexibilité totale", desc: "Adaptée à toutes les structures : PME, grandes entreprises et multi-organisations." }
            ].map((item, index) => (
              <div key={index} className="p-4 bg-white shadow-sm rounded text-center" style={{ transition: "0.3s", cursor: "default" }}>
                <item.icon size={40} className="mb-3" style={{ color: "#4A47A3" }} />
                <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>{item.title}</h4>
                <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* NOUVEAU : Innovation & Primes */}
        <section style={{ marginBottom: "70px" }}>
          <h2 style={{ fontWeight: 700, fontSize: "2rem", textAlign: "center", marginBottom: "50px" }}>
            <FaLightbulb style={{ color: "#f59e0b", marginRight: "10px" }} />
            Primes d'Innovation
          </h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "30px"
          }}>
            <div style={{ 
              background: "linear-gradient(135deg, #fef3c7, #fffbeb)",
              borderRadius: "16px",
              padding: "25px",
              border: "1px solid #fde68a"
            }}>
              <FaTrophy size={40} style={{ color: "#d97706", marginBottom: "15px" }} />
              <h3 style={{ fontWeight: 700, marginBottom: "15px", color: "#92400e" }}>Valorisez la créativité</h3>
              <p style={{ lineHeight: "1.6" }}>
                Encouragez vos employés à proposer des innovations qui améliorent vos processus. 
                Chaque idée compte et peut être récompensée.
              </p>
            </div>
            <div style={{ 
              background: "linear-gradient(135deg, #dcfce7, #f0fdf4)",
              borderRadius: "16px",
              padding: "25px",
              border: "1px solid #bbf7d0"
            }}>
              <FaStar size={40} style={{ color: "#16a34a", marginBottom: "15px" }} />
              <h3 style={{ fontWeight: 700, marginBottom: "15px", color: "#166534" }}>Évaluation structurée</h3>
              <p style={{ lineHeight: "1.6" }}>
                Définissez des critères personnalisés, désignez des évaluateurs et calculez 
                automatiquement les scores pour une attribution juste des primes.
              </p>
            </div>
            <div style={{ 
              background: "linear-gradient(135deg, #e0e7ff, #eef2ff)",
              borderRadius: "16px",
              padding: "25px",
              border: "1px solid #c7d2fe"
            }}>
              <FaGift size={40} style={{ color: "#4f46e5", marginBottom: "15px" }} />
              <h3 style={{ fontWeight: 700, marginBottom: "15px", color: "#3730a3" }}>Primes automatiques</h3>
              <p style={{ lineHeight: "1.6" }}>
                Configurez des barèmes de primes basés sur les scores obtenus. 
                Le système calcule et attribue automatiquement les primes aux innovateurs.
              </p>
            </div>
          </div>
          
          {/* Processus d'innovation */}
          <div style={{
            marginTop: "40px",
            background: "#f9fafb",
            borderRadius: "16px",
            padding: "30px",
            border: "1px solid #e5e7eb"
          }}>
            <h3 style={{ fontWeight: 700, textAlign: "center", marginBottom: "30px", color: "#1B019B" }}>
              Comment ça fonctionne ?
            </h3>
            <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: "20px",
              textAlign: "center"
            }}>
              {[
                { step: "1", title: "Soumission", desc: "L'employé soumet son innovation avec description et domaine" },
                { step: "2", title: "Désignation", desc: "Les responsables désignent des évaluateurs qualifiés" },
                { step: "3", title: "Évaluation", desc: "Les évaluateurs notent selon des critères prédéfinis" },
                { step: "4", title: "Prime", desc: "Prime automatiquement attribuée selon le score obtenu" }
              ].map((item, idx) => (
                <div key={idx}>
                  <div style={{
                    width: "50px",
                    height: "50px",
                    background: "#1B019B",
                    color: "white",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 15px auto",
                    fontWeight: "bold",
                    fontSize: "1.5rem"
                  }}>{item.step}</div>
                  <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>{item.title}</h4>
                  <p style={{ fontSize: "0.9rem", color: "#6b7280" }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Application mobile */}
        <section style={{ marginBottom: "70px", display: "flex", flexWrap: "wrap", alignItems: "center", gap: "50px", justifyContent: "center" }}>
          <div style={{ flex: "1 1 400px", textAlign: "center" }}>
            <img src={logo} alt="Application Mobile" style={{ width: "250px", borderRadius: "20px", boxShadow: "0 8px 20px rgba(0,0,0,0.2)" }} />
          </div>
          <div style={{ flex: "1 1 400px", maxWidth: "500px" }}>
            <h3 style={{ fontWeight: 700, fontSize: "1.8rem", marginBottom: "20px" }}>📱 Une application mobile</h3>
            <p style={{ fontSize: "1.05rem", lineHeight: "1.7" }}>
              Notre application mobile permet à chaque employé de pointer rapidement via <strong>QR Code</strong> ou <strong>badge</strong> et une <strong>photo</strong> de l'employé prise lors du pointage. 
              Les responsables disposent d’une interface pour superviser l’ensemble de leur équipe et effectuer les pointages en cas de besoin. 
              Tout est synchronisé automatiquement pour garantir la fiabilité des données, même en mode hors-ligne.
            </p>
          </div>
        </section>

        {/* Fonctionnalités principales */}
        <section style={{ marginBottom: "70px" }}>
          <h2 style={{ fontWeight: 700, fontSize: "2rem", textAlign: "center", marginBottom: "50px" }}>
            ⚙️ Fonctionnalités clés
          </h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px",
            textAlign: "center"
          }}>
            {[
              { icon: FaMobileAlt, title: "Application mobile", desc: "Pointage en temps réel et notifications instantanées." },
              { icon: FaQrcode, title: "QR Code & badge", desc: "Identification rapide et sécurisée des employés." },
              { icon: FaUserCheck, title: "Suivi complet", desc: "Gestion des présences, retards et absences avec validation automatique par les responsables." },
              { icon: FaUsers, title: "Pointage par responsable", desc: "Les responsables peuvent pointer pour leurs équipes et gérer les justifications de retards ou d'absences." },
              { icon: FaIdBadge, title: "Activités exceptionnelles", desc: "Planification et suivi des activités spéciales avec pointage et heures supplémentaires." },
              { icon: FaFilePdf, title: "Rapports & Reporting", desc: "Export PDF et analyses détaillées pour le suivi des présences, retards, absences et primes." },
              { icon: FaBell, title: "Demandes & Notifications", desc: "Les employés peuvent signaler des retards, soumettre des demandes d'absence et recevoir des notifications instantanées." },
              { icon: FaClock, title: "Heures supplémentaires", desc: "Suivi et validation des heures supplémentaires avec calcul automatique des montants." },
              { icon: FaWifi, title: "Mode hors-ligne", desc: "Synchronisation automatique dès que le réseau est disponible des pointages." },
              // NOUVEAU : Innovation
              { icon: FaLightbulb, title: "Primes d'innovation", desc: "Soumettez, évaluez et récompensez les idées innovantes avec des primes automatiques." },
              { icon: FaMedal, title: "Reconnaissance", desc: "Valorisez l'excellence et la créativité de vos équipes." },
            ].map((item, index) => (
              <div key={index} className="p-3 bg-white shadow-sm rounded" style={{ transition: "0.3s" }}>
                <item.icon size={30} className="mb-2" style={{ color: "#4A47A3" }} />
                <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>{item.title}</h4>
                <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Pénalités et Primes */}
        <section style={{ marginBottom: "70px", textAlign: "center" }}>
          <h2 style={{ fontWeight: 700, fontSize: "1.9rem", marginBottom: "40px" }}>💰 Gestion des pénalités et primes</h2>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "30px",
            justifyItems: "center"
          }}>
            <div className="p-4 bg-white shadow-sm rounded" style={{ maxWidth: "350px" }}>
              <FaIdBadge size={35} style={{ color: "#4A47A3", marginBottom: "15px" }} />
              <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>Pénalités pour retard</h4>
              <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Les retards sont automatiquement détectés et peuvent générer des pénalités financières selon vos paramètres : 
                montant fixe, par minute ou par heure de retard. Tout est configurable pour s’adapter à votre organisation.
              </p>
            </div>
            <div className="p-4 bg-white shadow-sm rounded" style={{ maxWidth: "350px" }}>
              <FaBell size={35} style={{ color: "#4A47A3", marginBottom: "15px" }} />
              <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>Primes de ponctualité</h4>
              <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Les employés ponctuels peuvent recevoir des primes mensuelles de ponctualité. 
                Tout est calculé automatiquement et intégré aux rapports pour valoriser la régularité.
              </p>
            </div>
            <div className="p-4 bg-white shadow-sm rounded" style={{ maxWidth: "350px" }}>
              <FaTrophy size={35} style={{ color: "#d97706", marginBottom: "15px" }} />
              <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>Primes d'innovation</h4>
              <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Récompensez les employés qui proposent des innovations ayant un impact positif sur l'organisation. 
                Évaluation multicritère et primes automatiques selon les scores obtenus.
              </p>
            </div>
            <div className="p-4 bg-white shadow-sm rounded" style={{ maxWidth: "350px" }}>
              <FaFilePdf size={35} style={{ color: "#4A47A3", marginBottom: "15px" }} />
              <h4 style={{ fontWeight: 600, marginBottom: "10px" }}>Rapports détaillés</h4>
              <p style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                Toutes les pénalités et primes sont disponibles dans des rapports PDF interactifs, 
                pour un suivi clair et transparent de la rémunération liée aux présences et à l'innovation.
              </p>
            </div>
          </div>
        </section>

        {/* Valeur ajoutée */}
        <section style={{ marginBottom: "70px", textAlign: "center" }}>
          <h2 style={{ fontWeight: 700, fontSize: "1.9rem", marginBottom: "25px" }}>💡 Valeur ajoutée pour votre organisation</h2>
          <p style={{ maxWidth: "850px", margin: "auto", fontSize: "1.05rem", lineHeight: "1.7" }}>
            Grâce à notre solution, le suivi des présences devient simple, précis et sécurisé. Les employés peuvent pointer depuis l'application mobile, 
            les responsables supervisent leurs équipes, et les données sont automatiquement synchronisées pour un reporting fiable et instantané. 
            Les pénalités et primes sont calculées automatiquement, favorisant la discipline et récompensant la ponctualité.
            <br /><br />
            <strong>En plus, notre nouveau module <span style={{ color: "#d97706" }}>Primes d'Innovation</span> permet de valoriser la créativité de vos équipes 
            et de transformer les bonnes idées en bénéfices concrets pour l'entreprise.</strong>
          </p>
        </section>

        {/* Contact */}
        <section style={{ padding: "60px 20px", background: "#f8f9fa", borderRadius: "12px" }}>
          <h2 
            style={{ 
              fontWeight: 700, 
              fontSize: "2rem", 
              textAlign: "center", 
              marginBottom: "50px", 
              position: "relative",
              display: "inline-block",
              whiteSpace: "nowrap",
              width: "100%"
            }}
          >
            <span style={{
              color: " #1B019B",
              display: "inline-block",
              animation: "bounceText 2s ease-in-out infinite"
            }}>
              📞 Contactez-nous
            </span>
          </h2>

          <div className="d-flex flex-wrap justify-content-center gap-4">
            {[
              { icon: "📧", title: "Email", info: <a href="mailto:info@enumera.africa">info@enumera.africa</a> },
              { icon: "📞", title: "Téléphone", info: "+226 55 87 87 01" },
              { icon: "📍", title: "Adresse", info: "Bobo-Dioulasso, Burkina Faso" },
              { icon: "🌐", title: "Site web", info: <a href="https://enumera.africa" target="_blank" rel="noopener noreferrer">enumera.africa</a> }
            ].map((item, index) => (
              <div 
                key={index} 
                className="p-4 bg-white shadow rounded text-center contact-card" 
                style={{ flex: "1 1 250px", transition: "transform 0.3s, box-shadow 0.3s" }}
              >
                <h5 style={{ fontWeight: 600, fontSize: "1.1rem" }}>{item.icon} {item.title}</h5>
                <p style={{ fontSize: "0.95rem", marginTop: "10px" }}>{item.info}</p>
              </div>
            ))}
          </div>

          {/* Animation CSS */}
          <style>{`
            @keyframes bounceText {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
            }

            .contact-card:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 25px rgba(0,0,0,0.2);
            }

            a {
              text-decoration: none;
              color: #1B019B;
              font-weight: 500;
              transition: color 0.3s;
            }

            a:hover {
              color: #4A47A3;
            }
          `}</style>
        </section>
      </main>
    </div>
  );
}

export default About;